import gql from 'graphql-tag'

export const newCurrentBookPref = gql`
  mutation newCurrentBookPref(
    $isCurrent: Boolean!
    $bookId: ID!
    $userId: ID!
  ) {
    createBookPref(isCurrent: $isCurrent, bookId: $bookId, userId: $userId) {
      id
    }
  }
`

export const updateCurrentBookPref = gql`
  mutation updateCurrentBookPref($isCurrent: Boolean!, $id: ID!, $userId: ID!) {
    updateBookPref(isCurrent: $isCurrent, id: $id, userId: $userId) {
      id
    }
  }
`

export const updateBookPref = gql`
  mutation updateBookPref(
    $maxPage: Int
    $percentRead: Int
    $id: ID!
    $userId: ID!
  ) {
    updateBookPref(
      maxPage: $maxPage
      percentRead: $percentRead
      id: $id
      userId: $userId
    ) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/bookPref.js